// Must be called synchronously from a real user gesture (a click) — browsers reject
// requestFullscreen() calls that aren't tied to one, so this can't be called from a
// setTimeout, a promise callback, or any other delayed path.
export const requestFullscreen = () => {
  // A denied request is an expected outcome — the student can refuse the browser prompt, and an
  // iframe without allowfullscreen can't enter fullscreen at all — so it must never break the
  // assessment.
  document.documentElement.requestFullscreen?.().catch(() => {});
};

export const exitFullscreen = () => {
  if (document.fullscreenElement) {
    document.exitFullscreen?.().catch(() => {});
  }
};
